module.exports = __webpack_public_path__ + "media/beep-10.38870375.mp3";